import React from "react";


const Header = ()=>{
    return (
        <>
        <header className="header-section">
            <div className="logo"><a href="">Softgray</a></div>
            <nav>
                <div className="menu">
                    <a href="#">Products</a>
                    <a href="#">Services</a>
                    <a href="#">About</a>
                    <a href="#">Jobs</a>
                    <a href="#">Contact</a>
                </div>
                <div className="mobile-no">+91-62-6754-5434</div>
                {/* <i className="fa-solid fa-bars menu-icon"></i> */}
            </nav>
        </header>
        </>
    )
}

export default Header;